import { PersonLink } from "@/components/common/PersonLink";
import { useIntl } from "react-intl";
import { OwnerAccessRow } from "@/components/match/MatchModals";
import { APPLICATION_LEVEL_LABELS, APPLICATIONS_LABEL, LISTING_ROLE_LABELS, listingRole } from "./listing-access";
import { useListing } from "./use-listing";

// Das Team einer Ausschreibung: die Eigentümerin und die Mitglieder mit Rolle und Stufe auf Bewerbungen,
// wie in den Einstellungen (listing-access.ts). Geändert wird das dort.
export function ListingTeamFacet({ listingId }: { listingId: string }) {
  const intl = useIntl();
  const { listing } = useListing(listingId);
  if (!listing?.access) return null;
  const members = listing.access.filter(member => member.person.id !== listing.createdBy?.id);

  return (
    <div className="max-w-3xl divide-y divide-ink/5">
      {listing.createdBy ? <OwnerAccessRow size="md" name={<PersonLink size="md" person={{ id: listing.createdBy.id, name: listing.createdBy.formattedName || "–",
        avatarContent: listing.createdBy.avatar?.content, avatarMime: listing.createdBy.avatar?.mimeType }} />} /> : null}
      {members.map((member) => (
        <div key={member.person.id} className="flex items-center justify-between gap-3 py-3">
          <div className="min-w-0 truncate text-smycles-body font-medium">
            <PersonLink size="md" person={{ id: member.person.id, name: member.person.formattedName || "–",
              avatarContent: member.person.avatar?.content, avatarMime: member.person.avatar?.mimeType }} />
          </div>
          <div className="text-right text-smycles-meta text-ink-muted">
            {[
              intl.formatMessage(LISTING_ROLE_LABELS[listingRole(member)]),
              `${intl.formatMessage(APPLICATIONS_LABEL)}: ${intl.formatMessage(APPLICATION_LEVEL_LABELS[member.applications])}`,
            ].join(" · ")}
          </div>
        </div>
      ))}
    </div>
  );
}
